import { List, Map, fromJS } from 'immutable';

export function request(state, { userId, bet }) {
    let userBets = state.getIn([ 'bets', userId ]);
    let userLegs = state.getIn([ 'legs', userId ]);

    if (bet.splittedFrom) {
        bet = userBets.find( x => x.get('uid') === bet.splittedFrom).toJS();
    }

    bet.stakePerLine = Math.round((bet.stakePerLine * 2) * 100) / 100;

    let betIndex = userBets.findIndex( x => x.get('uid') === bet.uid);
    delete bet.isSplitted;

    userBets = userBets.set(betIndex, fromJS(bet));
    userBets = userBets.filter( x => x.get('uid') !== x.get('splittedTo'));

    userLegs = userLegs.filter( l => !l.get('isSplitted'));

    state = state.setIn([ 'legs', userId ], userLegs);
    state = state.set(
        'bets',
        state.get('bets').set(
            userId,
            userBets
        )
    );

    return state;
}
